import { render, staticRenderFns } from "./relationTestPaperList.vue?vue&type=template&id=67d40a64&scoped=true"
import script from "./relationTestPaperList.vue?vue&type=script&lang=js"
export * from "./relationTestPaperList.vue?vue&type=script&lang=js"
import style0 from "./relationTestPaperList.vue?vue&type=style&index=0&id=67d40a64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d40a64",
  null
  
)

export default component.exports